module.exports = __webpack_public_path__ + "static/img/308.37fbcc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201206/308.jpg
// module id = ZrIu
// module chunks = 0